export enum EmploymentConditionsConfirmationStatusEnum {
  Draft = 1,
  PendingGeneration = 2,
  Generated = 3,
  Signed = 4,
  Read = 5,
  NoConfirmation = 6
}